<template>
  <div class="comment-footer" @mouseleave="showUserList = false">
    <div class="control-buttons">
      <edi-reply-comment-btn
        v-disable="isReplyCommentBtnDisabled"
        @click="reply({ userId, commentId, userNick })"
      />
      <div class="like-dislike">
        <edi-comment-valuation-btn
          @hover="checkUserLikes"
          @click="vote({ commentId, contentId })"
          :total="likes"
          :positive="true"
          :show-user-list="showUserList"
          :users="users"
          :active="isLikedComment(commentId)"
          :disabled="!isLogged || isOwnComment(userNick) || !isUserCommentable(this.commentType)"
        />
      </div>
      <edi-more-options-btn
        @click="showOptions = !showOptions"
        :active="!!showOptions"
        v-if="!isAuthor && !isOwnComment(userNick) && isLogged && isUserCommentable(this.commentType)"/>
      <transition name="more-options-animation">
        <edi-dropdown-modal class="more-options-wrapper" v-if="showOptions">
          <edi-moderate-comment-btn @click="report(commentId)" :total="moderatedVotes"/>
          <edi-mute-comment-btn @click="muteUser(userId)"/>
        </edi-dropdown-modal>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EdiDropdownModal, EdiMoreOptionsBtn } from '../../components';
import EdiReplyCommentBtn from './reply/EdiReplyCommentBtn.vue';
import {
  EdiModerateCommentBtn,
  EdiMuteCommentBtn,
  EdiCommentValuationBtn,
} from './index';

export default {
  name: 'edi-comment-actions',
  components: {
    EdiReplyCommentBtn,
    EdiMoreOptionsBtn,
    EdiModerateCommentBtn,
    EdiMuteCommentBtn,
    EdiCommentValuationBtn,
    EdiDropdownModal,
  },
  props: {
    likes: Number,
    dislikes: Number,
    moderatedVotes: Number,
    commentId: Number,
    contentId: Number,
    userId: Number,
    userNick: String,
    isAuthor: Boolean,
    commentType: Number,
  },
  data() {
    return {
      showOptions: false,
      showUserList: false,
      users: [],
    };
  },
  computed: {
    ...mapGetters([
      'commentUserLikesList',
      'isLikedComment',
      'isOwnComment',
      'isLogged',
      'isUserCommentable',
    ]),
    isReplyCommentBtnDisabled() {
      return !this.isLogged || this.isOwnComment(this.userNick) || !this.isUserCommentable(this.commentType);
    },
  },
  methods: {
    ...mapActions([
      'vote',
      'votes',
      'report',
      'replyUser',
      'muteUser',
    ]),
    reply({ userId, commentId, userNick }) {
      if (!this.isOwnComment(this.userNick) && this.isLogged && this.isUserCommentable(this.commentType)) {
        window.dataLayer.push({
          event: 'comment_interaction',
          eventData: {
            im_action: 'responder',
            content_id: this.contentId.toString(),
          },
        });
        this.replyUser({ userId, commentId, userNick });
        this.$nextTick(() => {
          document.getElementById('edi-comments').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    },
    async checkUserLikes() {
      if (this.isLogged) {
        this.showUserList = true;
        await this.votes({ commentId: this.commentId, isPositive: true });
        // FIXME: esto debería funcionar igual que los usuarios silenciados,
        // por cuestiones de tiempo y wtf, he hecho esta ñapa, si ves esto
        // inténtalo hacer bien pls
        this.users = this.commentUserLikesList(this.commentId);
      }
    },
  },
};
</script>

<style scoped>
  .more-options-animation-enter-active, .more-options-animation-leave-active{
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .more-options-animation-enter, .more-options-animation-leave-to {
    opacity: 0;
  }
</style>
